// import { useUsers } from "../../../hooks/use-user";
import { nameChangeData } from "../../../data/name-change";
import NameChangeRequestsTable from "../../shared/name-change/name-change-table";

export default function NameChangeDashboardPage() {
  //   const { data: users = [], isLoading, error } = useUsers();

  return (
    <div className="flex flex-col gap-5 @container 2xl:gap-x-6 2xl:gap-y-7 3xl:gap-8">
      <NameChangeRequestsTable
        requests={nameChangeData}
        isLoading={false}
        error={null}
      />
    </div>
  );
}
